/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Win_Back_Offer_Btn_DescriptionInputs */

const en_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/year after the offer period. Cancel anytime.`)
};

const ar_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} سنويًا بعد انتهاء العرض. يمكنك الإلغاء في أي وقت.`)
};

const de_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nach dem Angebotszeitraum ${i?.price}/Jahr. Jederzeit kündbar.`)
};

const es_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/año tras el período promocional. Puedes cancelar en cualquier momento.`)
};

const fr_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/an après la période promotionnelle. Résiliation à tout moment.`)
};

const it_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/anno al termine del periodo promozionale. Puoi annullare in qualsiasi momento.`)
};

const ja_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`特典期間終了後は年額${i?.price}。いつでも解約できます。`)
};

const ko_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`혜택 기간 종료 후 연간 ${i?.price}. 언제든 구독을 취소할 수 있어요.`)
};

const pt_br_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/ano após o período da oferta. Cancele quando quiser.`)
};

const ru_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} в год после окончания акции. Отменить подписку можно в любое время.`)
};

const th_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`หลังสิ้นสุดช่วงข้อเสนอ ราคา ${i?.price}/ปี ยกเลิกได้ทุกเมื่อ`)
};

const tr_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teklif dönemi sonrası yıllık ${i?.price}. İstediğin zaman iptal et.`)
};

const zh_cn_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`优惠期结束后每年 ${i?.price}，可随时取消订阅。`)
};

const zh_tw_win_back_offer_btn_description = /** @type {(inputs: Win_Back_Offer_Btn_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`優惠期結束後每年 ${i?.price}，可隨時取消訂閱。`)
};

/**
* | output |
* | --- |
* | "{price}/year after the offer period. Cancel anytime." |
*
* @param {Win_Back_Offer_Btn_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_offer_btn_description = /** @type {((inputs: Win_Back_Offer_Btn_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Offer_Btn_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_offer_btn_description(inputs)
	if (locale === "ar") return ar_win_back_offer_btn_description(inputs)
	if (locale === "de") return de_win_back_offer_btn_description(inputs)
	if (locale === "es") return es_win_back_offer_btn_description(inputs)
	if (locale === "fr") return fr_win_back_offer_btn_description(inputs)
	if (locale === "it") return it_win_back_offer_btn_description(inputs)
	if (locale === "ja") return ja_win_back_offer_btn_description(inputs)
	if (locale === "ko") return ko_win_back_offer_btn_description(inputs)
	if (locale === "pt_br") return pt_br_win_back_offer_btn_description(inputs)
	if (locale === "ru") return ru_win_back_offer_btn_description(inputs)
	if (locale === "th") return th_win_back_offer_btn_description(inputs)
	if (locale === "tr") return tr_win_back_offer_btn_description(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_offer_btn_description(inputs)
	return zh_tw_win_back_offer_btn_description(inputs)
});